<template>
  <BIconCircle class="circle-icon" />
</template>

<script setup>
import { BIconCircle } from "bootstrap-icons-vue";
</script>

<style lang="scss" scoped>
.circle-icon {
  border: 2px solid $bluish-gray-800;
  border-radius: 50%;
  width: 0.75rem;
  height: 0.75rem;
}
</style>
